import { render, staticRenderFns } from "./KleptoBuilder.vue?vue&type=template&id=81e9b886&scoped=true&"
import script from "./KleptoBuilder.vue?vue&type=script&lang=js&"
export * from "./KleptoBuilder.vue?vue&type=script&lang=js&"
import style0 from "./KleptoBuilder.vue?vue&type=style&index=0&id=81e9b886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e9b886",
  null
  
)

export default component.exports